import $ from 'jquery';

const kendo$ = ((window as any).kendo?.jQuery ?? $) as JQueryStatic;
import { guid } from "@common/Guid";

export class KendoChart
{
    IsFullScreen: boolean = false;

    public ElementId = `Chart-${guid()}`;

    Title: string = "Chart";

    private ChartOptions: KendoChartOptions;

    private constructor(options: KendoChartOptions)
    {
        this.ChartOptions = options;
    }

    private Get(): kendo.dataviz.ui.Chart
    {
        return kendo$(`#${this.ElementId}`).data("kendoChart");
    }

    private GetChartDomElement(): Element
    {
        const elem = kendo$(`#${this.ElementId}`).get()[0];
        return elem;
    }

    public UpdateOptions()
    {
        const chart = this.Get();

        if (chart)
        {
            chart.setOptions(this.ChartOptions.Get());
        }
    }

    Destroy()
    {
        const chart = this.Get();

        if (chart)
        {
            chart.destroy();
        }
    }

    
    static CreateChart(options: KendoChartOptions): KendoChart
    {
        return new KendoChart(options);
    }


    static CreateColumnChart(options: KendoChartOptions): KendoChart
    {
        options.SetColumnSeriesType();
        return new KendoChart(options);
    }

    static CreatePieChart(options: KendoChartOptions): KendoChart
    {
        options.SetPieSeriesType();
        return new KendoChart(options);
    }

    static CreateBubbleChart(options: KendoChartOptions): KendoChart
    {
        options.SetBubbleSeriesType();
        return new KendoChart(options);
    }

    static CreateScatterChart(options: KendoChartOptions): KendoChart
    {
        options.SetScatterSeriesType();
        return new KendoChart(options);
    }


    GetOptions(): KendoChartOptions
    {
        return this.ChartOptions;
    }


    Render()
    {
        const chart = this.Get();

        if (chart == null)
        {
            kendo$(`#${this.ElementId}`).kendoChart(this.ChartOptions.Get());
        }        
    }

    Render1(chartId: string)
    {
        this.ElementId = `Chart-${chartId}`;

        if (kendo$(`#${this.ElementId}`).length > 0)
        {
            // The element exists, initialize the Kendo Chart
            kendo$(`#${this.ElementId}`).kendoChart(this.ChartOptions.Get());
        } else
        {
            // The element does not exist
            console.log(`Element ${this.ElementId} does not exist`);
        }
    }

    IsInViewPort(): boolean
    {
        const domElement = this.GetChartDomElement();

        const elementTop = kendo$(domElement).offset().top;
        const elementBottom = elementTop + kendo$(domElement).outerHeight();

        const viewportTop = kendo$(window).scrollTop();
        const viewportBottom = viewportTop + kendo$(window).height();

        return elementBottom > viewportTop && elementTop < viewportBottom;
    }


    SetTheme(theme: string)
    {
        this.ChartOptions.SetTheme(theme);
        this.UpdateOptions();
    }

    //SetLegend(visible: boolean, position: string)
    //{
    //    this.ChartOptions.SetLegend(visible, position, null);
    //    this.UpdateOptions();
    //}     


    SetDataSeries(series: KendoChartDataSerie[])
    {
        this.ChartOptions.SetSeries(series);       
    }

    SetOptions(options: KendoChartOptions)
    {
        this.ChartOptions = options;        
    }

    SetHeight(height: number)
    {
        this.ChartOptions.SetHeight(height);
    }




    ToggleHighlight(show: boolean, options: any)
    {
        const chart = this.Get();

        if (chart)
        {
            chart.toggleHighlight(show, options);
        }
    }

    HideTooltip()
    {
        const chart = this.Get();

        if (chart)
        {
            chart.hideTooltip();
        }
    }

    // eslint-disable-next-line @typescript-eslint/ban-types
    ShowTooltip(filter: Function)
    {
        const chart = this.Get();

        if (chart)
        {
            chart.showTooltip(filter);
        }
    }
}

export class KendoChartDataSerie
{
    private Serie: kendo.dataviz.ui.ChartSeriesItem =
    {
        //field: "Value",
        //xField: "X",
        //yField: "Y",
        //categoryField: string = "Name";
        labels: {},
        markers: {},
        data: []
    };

    Get(): kendo.dataviz.ui.ChartSeriesItem
    {
        return this.Serie;
    }

    SetName(name: string)
    {
        this.Serie.name = name;
    }

    SetField(field: string)
    {
        this.Serie.field = field;
    }

    SetXField(xField: string)
    {
        this.Serie.xField = xField;
    }

    SetYField(yField: string)
    {
        this.Serie.yField = yField;
    }

    SetCategoryField(categoryField: string)
    {
        this.Serie.categoryField = categoryField;
    }

    SetColorField(colorField: string)
    {
        this.Serie.colorField = colorField;
    }

    SetSizeField(sizeField: string)
    {
        this.Serie.sizeField = sizeField;
    }

    SetColor(color: string)
    {
        this.Serie.color = color;
    }

    EnableAutoFit()
    {
        //https://docs.telerik.com/kendo-ui/api/javascript/dataviz/ui/chart/configuration/series.autofit
        (this.Serie as any).autoFit = true;
    }

    SetLabels(visible: boolean, template: string, font: string, position: string)
    {
        if (visible != null)
        {
            this.Serie.labels.visible = visible;
        }

        if (template != null)
        {
            this.Serie.labels.template = template;
            //bar chart labels insideBase were adding additional color
            this.Serie.labels.background = "transparent";
        }

        if (font != null)
        {
            this.Serie.labels.font = font;
        }

        if (position != null)
        {
            this.Serie.labels.position = position;
        }
    }

    SetLabelsAlign(align: string)
    {
        this.Serie.labels.align = align;
    }

    SetLabelsColor(color: string)
    {
        this.Serie.labels.color = color;
    }

    SetMarkers(visible: boolean, type: string)
    {
        if (visible != null)
        {
            this.Serie.markers.visible = visible;
        }

        if (type != null)
        {
            this.Serie.markers.type = type;
        }        
    }

    SetData(data: any[])
    {
        this.Serie.data = data;
    }
}

export class KendoChartOptions
{
    private Options: kendo.dataviz.ui.ChartOptions =
    {
        chartArea: {},
        renderAs: "canvas",
        transitions: false,
        theme: "Default",
        title: { text: "" },
        tooltip: { visible: true },
        legend: { visible: true, position: "top", labels: {} },
        pannable: false,
            zoomable: false,
            seriesDefaults: {
                type: "bar", stack: false,
                overlay: { gradient: "none" }
            },
        series: [],
        valueAxis: [],
        categoryAxis: [],
        xAxis: {},
        yAxis: {}
    };

    Get(): kendo.dataviz.ui.ChartOptions
    {
        return this.Options;
    }

    SetTheme(theme: string)
    {
        this.Options.theme = theme;
    }

    SetTitle(title: string)
    {
        this.Options.title = title;
    }


    private SetSeriesType(type: string)
    {
        this.Options.seriesDefaults.type = type;
    }

    SetBarSeriesType()
    {
        this.SetSeriesType("bar");
    }

    SetColumnSeriesType()
    {
        this.SetSeriesType("column");
    }

    SetPieSeriesType()
    {
        this.SetSeriesType("pie");
    }

    SetDonutSeriesType()
    {
        this.SetSeriesType("donut");
    }

    SetRadarSeriesType()
    {
        this.SetSeriesType("radarLine");
    }

    SetBubbleSeriesType()
    {
        this.SetSeriesType("bubble");
    }

    SetScatterLineSeriesType()
    {
        this.SetSeriesType("scatterLine");
    }

    SetScatterSeriesType()
    {
        this.SetSeriesType("scatter");
    }    

    

    SetSeriesStack(stack: boolean)
    {
        this.Options.seriesDefaults.stack = stack;
    }

    EnableSeriesStack100()
    {
        this.Options.seriesDefaults.stack = { type: "100%"};
    }

    SetSeries(series: KendoChartDataSerie[])
    {
        this.Options.series = series.map(s => s.Get());
    }

    SetPannable(pannable: boolean)
    {
        this.Options.pannable = pannable;
    }

    SetZoomable(zoomable: boolean)
    {
        this.Options.zoomable = zoomable;
    }

    SetTooltip(visible: boolean, template: string)
    {
        if (visible != null)
        {
            this.Options.tooltip.visible = visible;
        }

        if (template != null)
        {
            this.Options.tooltip.template = template;
        }        
    }

    SetLegend(visible: boolean, position: string, charLimit?: number)
    {
        if (visible != null)
        {
            this.Options.legend.visible = visible;
        }

        if (position != null)
        {
            this.Options.legend.position = position;
        }

        if (charLimit != null)
        {
            this.Options.legend.labels.template = `#= series.name.length > ${charLimit} ? series.name.substring(0, ${charLimit - 3}) + '...' : series.name #`;
        } else
        {
            this.Options.legend.labels.template = "#= series.name #"; // No truncation if charLimit is not provided
        }

        this.Options.legend.labels.font = "1rem Arial";
    }



    //SetLegend(visible: boolean, position: string, labelsTemplate: string, labelsFont: string)
    //{
    //    if (visible != null)
    //    {
    //        this.Options.legend.visible = visible;
    //    }

    //    if (position != null)
    //    {
    //        this.Options.legend.position = position;
    //    }

    //    if (labelsTemplate != null)
    //    {
    //        this.Options.legend.labels.template = labelsTemplate;
    //    }

    //    if (labelsFont != null)
    //    {
    //        this.Options.legend.labels.font = labelsFont;
    //    }
    //}

    HideLegend()
    {
        this.Options.legend.visible = false;
    }



    SetHeight(height: number)
    {
        //console.log(height);
        this.Options.chartArea.height = height;
        //console.log(this.Options.chartArea.height);
    }

    SetWidth(width: number)
    {
        if (width > 400)
        {
            this.Options.chartArea.width = width;
        }
    }

    SetXAxis(majorUnit: number | null,
        min: number,
        max: number,
        titleText: string,
        labelsFormat: string | null,
        labelsStep: number,
        crosshairVisible: boolean,
        crosshairTooltipVisible: boolean,
        crosshairTooltipFormat: string | null,
        crosshairTemplate?: (e: any) => string)
    {
        this.Options.xAxis =
        {
            majorUnit: majorUnit ?? undefined,
            min: min,
            max: max,
            title:
            {
                text: titleText
            },
            labels:
            {
                format: labelsFormat ?? undefined,
                step: labelsStep
            },
            crosshair:
            {
                visible: crosshairVisible,
                tooltip:
                {
                    visible: crosshairTooltipVisible,
                    format: crosshairTooltipFormat ?? undefined,
                    template: crosshairTemplate
                }
            }
        };
    }


    SetYAxis(majorUnit: number | null,
        min: number,
        max: number,
        titleText: string,
        labelsFormat: string | null,
        crosshairVisible: boolean,
        crosshairTooltipVisible: boolean,
        crosshairTooltipFormat: string | null,
        crosshairTemplate?: (e: any) => string)
    {
        this.Options.yAxis =
        {
            majorUnit: majorUnit ?? undefined,
            min: min,
            max: max,
            title:
            {
                text: titleText
            },
            labels:
            {
                format: labelsFormat ?? undefined
            },
            crosshair:
            {
                visible: crosshairVisible,
                tooltip:
                {
                    visible: crosshairTooltipVisible,
                    format: crosshairTooltipFormat ?? undefined,
                    template: crosshairTemplate
                }
            }
        };
    }

    SetCategoryAxis(visible: boolean, majorGridLinesVisible: boolean, labelsFont?: string)
    {
        const categoryAxis = (Array.isArray(this.Options.categoryAxis) && this.Options.categoryAxis.length > 0) ?
            this.Options.categoryAxis[0] : {};

        //const categoryAxis = (this.Options.categoryAxis != null && this.Options.categoryAxis[0] != null) ?
        //    this.Options.categoryAxis[0] : {};

        if (visible != null)
        {
            categoryAxis.visible = visible;
        }

        if (majorGridLinesVisible != null)
        {
            categoryAxis.majorGridLines = categoryAxis.majorGridLines ?? {};
            categoryAxis.majorGridLines.visible = majorGridLinesVisible;
        }

        if (labelsFont)
        {
            categoryAxis.labels = {};
            categoryAxis.labels.font = labelsFont;
        }

        this.Options.categoryAxis = [categoryAxis];
    }



    SetValueAxis(max: number, lineVisible: boolean, minorGridLinesVisible: boolean)
    {
        const valueAxis = (Array.isArray(this.Options.valueAxis) && this.Options.valueAxis.length > 0) ?
            this.Options.valueAxis[0] : {};

        valueAxis.min = 0;

        if (max != null)
        {
            valueAxis.max = max;
        }

        if (lineVisible != null)
        {
            valueAxis.line = valueAxis.line ?? {};
            valueAxis.line.visible = lineVisible;
        }

        if (minorGridLinesVisible != null)
        {
            valueAxis.minorGridLines = valueAxis.minorGridLines ?? {};
            valueAxis.minorGridLines.visible = minorGridLinesVisible;
        }

        this.Options.valueAxis = [valueAxis];
    }

    SetOnSeriesClick(handler: (e: any) => void)
    {
        this.Options.seriesClick = handler;
    }

    SetOnSeriesHover(handler: (e: any) => void)
    {
        this.Options.seriesHover = handler;
    }
}